export default {
    _prefix: "ScorableHeader",
    labels: {
        closeSidePanel: "Close Side Panel",
        currentVersion: "Current Version",
        unsubmitted: "In Progress",
        submitted: "Completed",
        retractedVersion: (data: { retractedVersion: number }) =>
            `Retracted Version {{retractedVersion}}`,
        evaluationVersions: (data: { evaluationVersions: number }) =>
            `{{evaluationVersions}} Evaluation Versions`,
    },
};
